import { PAGINATION_RECORD_PER_PAGE } from "MainApp/features/App/constants";

export const CLOSE_FRIENDS_LIST_PER_PAGE = PAGINATION_RECORD_PER_PAGE;